<template>
  <div class="steps">
    <div class="steps__wrapper">
      <div v-for="(step, index) in steps" :key="index" :class="['steps__item', { 'steps__item--active': index + 1 == currentStep } ]">
        <div :class="['steps__index steps__index--' + (index + 1)]">{{ index + 1 }}</div>
        <h3 class="steps__title">{{ step }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Steps",
  props: ["currentStep"],
  data() {
    return {
      steps: [
        "Dane demograficzne",
        "Dane medyczne",
        "Wyniki badań",
        "Załączniki",
        "Uwagi",
        "Dziękujemy"
      ]
    };
  }
};
</script>

<style lang="scss">
.steps {
  position: relative;
  margin: 20px;
  border-bottom: 1px solid #f1f1f1;
  &:before {
    content: " ";
    display: block;
    border-bottom: 1px solid #f1f1f1;
    position: absolute;
    width: 100%;
    top: 30px;
    z-index: 1;
  }
  &__wrapper {
    margin: auto;
    width: 95%;
    max-width: 1140px;
    display: flex;
    align-items: baseline;
  }
  &__item {
    flex: 1;
    text-align: center;
    padding: 0 20px;
    z-index: 2;
    &--active {
      & ~ .steps__item {
        filter: grayscale(1);
        color: #e5e5e5;
        .steps__index {
          background: #e5e5e5;
        }
      }
    }
  }
  &__index {
    font-size: 20px;
    font-weight: bold;
    color: white;
    background: #36baca;
    width: 60px;
    height: 60px;
    line-height: 60px;
    border-radius: 50%;
		margin: auto;
		&--1 { background: #1EA3AD }
		&--2 { background: #2AA59B }
		&--3 { background: #40A87B }
		&--4 { background: #58AC5A }
		&--5 { background: #71B035 }
		&--6 { background: #8AB413 }
  }
  &__title {
    font-weight: bold;
    letter-spacing: 1.6px;
    text-transform: uppercase;
  }
}
</style>